const DEPLOYED_API_ROOT = "https://saas-back-t7cj.onrender.com";

function getApiRoot() {
  const configured = process.env.REACT_APP_API_BASE_URL || "";
  if (configured) {
    return configured
      .replace(/\/$/, "")
      .replace(/\/api\/v1$/i, "")
      .replace(/\/api\/enrollme$/i, "")
      .replace(/\/api$/i, "");
  }
  if (typeof window !== "undefined" && window.location.hostname === "enrollme-s1e1.onrender.com") {
    return DEPLOYED_API_ROOT;
  }
  return "";
}

const API_ROOT = getApiRoot();
const BASE = `${API_ROOT}/api/enrollme/driver`;

async function reqBlob(path) {
  const res = await fetch(`${BASE}${path}`, { method: "GET", credentials: "include" });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw Object.assign(new Error(data.message || "Request failed"), { status: res.status });
  }
  return res.blob();
}

async function req(method, path, body, isFormData = false) {
  const opts = { method, credentials: "include" };
  if (body) {
    if (isFormData) {
      opts.body = body;
    } else {
      opts.headers = { "Content-Type": "application/json" };
      opts.body = JSON.stringify(body);
    }
  }
  const res = await fetch(`${BASE}${path}`, opts);
  const contentType = res.headers.get("content-type") || "";
  const data = contentType.includes("application/json")
    ? await res.json().catch(() => ({}))
    : {};
  if (!contentType.includes("application/json")) {
    throw Object.assign(new Error("API did not return JSON. Check REACT_APP_API_BASE_URL for the EnrollMe deployment."), { status: res.status, data });
  }
  if (!res.ok) throw Object.assign(new Error(data.message || "Request failed"), { status: res.status, data });
  return data;
}

export const driverApi = {
  login: (email, phone) => req("POST", "/login", { email, phone }),
  logout: () => req("POST", "/logout"),
  me: () => req("GET", "/me"),

  // Profile
  getProfile: () => req("GET", "/profile"),
  updateProfile: (data) => req("PATCH", "/profile", data),

  // Documents to sign
  getDocuments: () => req("GET", "/documents"),
  signDocument: (data) => req("POST", "/documents/sign", data),
  downloadSignedDoc: (documentId) => req("GET", `/documents/${documentId}/download`),

  // WC43
  submitWc43: (data) => req("POST", "/wc43", data),
  downloadWc43: () => req("GET", "/wc43/download"),
  markWc43Online: () => req("POST", "/wc43/mark-online"),

  // Uploads
  listUploads: () => req("GET", "/uploads"),
  uploadDoc: (formData) => req("POST", "/uploads", formData, true),
  getDocLink: (docId) => req("GET", `/uploads/${docId}/link`),

  // Company settings (for form pre-fill)
  getSettings: () => req("GET", "/settings"),

  // Insurance card
  getInsuranceCard: () => req("GET", "/insurance-card"),

  // Dashboard (single-call summary for the home screen)
  getDashboard: () => req("GET", "/dashboard"),

  // Earnings
  getEarnings: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return req("GET", `/earnings${qs ? "?" + qs : ""}`);
  },

  // Verification letter (PDF download)
  downloadVerificationLetter: async () => {
    const blob = await reqBlob("/verification-letter");
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Independent_Contractor_Verification.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  },

  // Messages
  listMessages: () => req("GET", "/messages"),
  replyToMessage: (id, body) => req("POST", `/messages/${id}/reply`, { body }),
  markRead: (id) => req("PATCH", `/messages/${id}/read`),
};
